// @hooks
import useSWR from "swr";

// @utils
import { chartApiUrl, fetcher } from "@/utils";

const endpoint = `${process.env.NEXT_PUBLIC_API_URL_V1}/roi`;

export function useRoiFromLaunch(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/from-launch`, variation) : null,
    fetcher,
  );
}

export function useRoiSinceHexLaunch(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/from-hex-launch`, variation) : null,
    fetcher,
  );
}

export function useQuarterlyRoi(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/quarterly`, variation) : null,
    fetcher,
  );
}

export function useYearlyRoi(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/yearly`, variation) : null,
    fetcher,
  );
}

export function useMonthlyRoi(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/monthly`, variation) : null,
    fetcher,
  );
}
